import { render, staticRenderFns } from "./ClientDetailCard.vue?vue&type=template&id=2c59f804&scoped=true"
import script from "./ClientDetailCard.vue?vue&type=script&lang=js"
export * from "./ClientDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c59f804",
  null
  
)

export default component.exports